export default {
  namespaced: true,
  state: {
    isInit: false,
    isMante: false,
  },
  mutations: {
    isInit(state) {
      state.isInit = true;
    },
    resetInit(state) {
      state.isInit = false;
    },
    onMante(state) {
      state.isMante = true;
    },
    offMante(state) {
      state.isMante = false;
    },
  },
  // 非同期処理が使える
  actions: {
    isInit(context) {
      context.commit('isInit');
    },
    resetInit(context) {
      context.commit('resetInit');
    },
    onMante(context) {
      context.commit('onMante');
    },
    offMante(context) {
      context.commit('offMante');
    },
  },
};
